<template>
    <div>
        <i-form label-position="top">
            <vs-row>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center">
                    <h2>Atualizar dados da empresa</h2>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" :class="errors.first('necessidade')?'pb-4':''">
                    <form-item :error="errors.first('necessidade')" label="Necessidade da empresa:" >
                        <i-input clearable v-model="form.necessidade" size="large" name="necessidade" v-validate="'required'" @input="onChange">
                        </i-input>
                    </form-item>
                </vs-col>
                <vs-row>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center">
                        <form-item label="Tamanho da empresa:">
                            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4" v-for="(item, index) in funcionarios" :key="index">
                                <vx-checkbox :label="item.label" :text="item.text" v-model="form.tamanho" :vs-value="item.label" name="tamanho" v-validate="'required'" @input="onChange"></vx-checkbox>
                            </vs-col>
                        </form-item>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center">
                        <span class="text-danger text-sm pl-3" v-show="errors.has('tamanho')">{{ errors.first('tamanho') }}</span>
                    </vs-col>
                </vs-row>
                <vs-row>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center">
                        <form-item label="Faturamento da empresa:">
                            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4" v-for="(item, index) in faturamentos" :key="index">
                                <vx-checkbox :text="item.text" v-model="form.faturamento" :vs-value="item.text" name="faturamento" v-validate="'required'" @input="onChange"></vx-checkbox>
                            </vs-col>
                        </form-item>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center">
                        <span class="text-danger text-sm pl-3" v-show="errors.has('faturamento')">{{ errors.first('faturamento') }}</span>
                    </vs-col>
                </vs-row>
                <vs-row>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center">
                        <form-item label="Segmento da empresa:">
                            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4" v-for="(item, index) in segmentos" :key="index">
                                <vs-radio v-model="form.segmento" vs-name="segmento" :vs-value="item.nome" name="segmento" v-validate="'required'" @input="onChange">{{item.nome}}</vs-radio>
                            </vs-col>
                        </form-item>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center">
                        <span class="text-danger text-sm pl-3" v-show="errors.has('segmento')">{{ errors.first('segmento') }}</span>
                    </vs-col>
                </vs-row>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center">
                    <form-item label="Pontos de acesso ao Sistema (computadores):">
                        <InputNumber
                            :min="0"
                            v-model="form.pontos_acesso"
                            size="large"
                            @on-change="onChange"
                            >
                        </InputNumber>
                    </form-item>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center">
                    <form-item label="Observações:">
                        <vue-editor :editorToolbar="editor" v-model="form.descricao" placeholder="Descreva..."
                       @input="onChange"></vue-editor>
                    </form-item>
                </vs-col>
            </vs-row>
        </i-form>
        <div class="floating-btn">
            <i-button v-show="show_save" @click="onSave" icon="md-checkmark" shape="circle" type="primary"></i-button>
        </div>
    </div>
</template>

<script>
const {editorToolbar} = require("../../../helpers/utils.js")
export default {
    props:{
        data:Array,
        show_save:Boolean
    },
    components: {
        VueEditor: () => import("vue2-editor").then(({VueEditor}) => VueEditor),
    },
    data:()=>({
        isChecked:false,
        form:{
            necessidade:'',
            tamanho:'',
            faturamento :'',
            segmento:'',
            pontos_acesso:null,
            descricao:''
        },
        funcionarios:[],
        faturamentos:[],
        segmentos:[],
        editor: editorToolbar,
    }),
    methods:{
        onSave() {
            this.$emit("input", this.form)
        },
        onChange() {
            this.$emit("change")
            this.show_button = true
        },
        async getBusiness() {
            const {data} = await this.$axios.get("consulta/bussiness");
            this.segmentos = data
        },
        async getCompabyProfitRange() {
            const {data} = await this.$axios.get("consulta/companyProfit");
            this.faturamentos = data.map(size => ({text: size.descricao, id: size.id_faturamento_empresa}));
        },
        async getEmployeesRange() {
            const {data} = await this.$axios.get("consulta/companySize");
            this.funcionarios = data.map(item => ({label: item.nome, text: item.descricao, id: item.id_tamanho_empresa}))
        },
    },
    created() {
        this.getBusiness()
        this.getCompabyProfitRange()
        this.getEmployeesRange()
    },
    watch:{
        'form.tamanho'(value){
            console.log(value)
        }
    }
}
</script>

<style lang="scss" scoped>
    h2{
        margin-bottom: 20px;
    }
    .ivu-form-item {
        width: 100%;
        margin: 10px;
    }
    .ivu-collapse {
        width: 100%;  
    }
    .ivu-date-picker {
        width: 100%;
    }
</style>